
import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { formStepApi } from "@/services/api";
import { DocumentForm, FormStep as FormStepType } from "@/models";
import StepItem from "./StepItem";

interface FormStepProps {
  form: DocumentForm;
  step: FormStepType;
  onFormUpdated: () => Promise<void>;
  preventFormSubmission?: boolean;
  dragHandleProps?: any;
}

const FormStep = ({ form, step, onFormUpdated, preventFormSubmission = false, dragHandleProps }: FormStepProps) => {
  const { toast } = useToast();
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  console.log(`Rendering FormStep component for step ID: ${step.id}, order: ${step.step_order}`);
  
  return (
    <div 
      data-form-step-id={step.id.toString()}
      data-testid={`form-step-${step.id}`}
      data-step-order={step.step_order}
      className="form-step-container"
    >
      <StepItem 
        step={step}
        onSectionUpdated={onFormUpdated}
        preventFormSubmission={preventFormSubmission}
        dragHandleProps={dragHandleProps}
      />
    </div>
  );
};

export default FormStep;
